// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.star-rating[data-v-59f5e490] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n[dir] .star[data-v-59f5e490] {\n  cursor: pointer;\n}\n[dir=ltr] .star[data-v-59f5e490] {\n  margin-right: 5px;\n}\n[dir=rtl] .star[data-v-59f5e490] {\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
